module.exports = __webpack_public_path__ + "static/media/asterisk.4e6b670f.svg";